"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return BaseGroup;
    }
});
const _konva = /*#__PURE__*/ _interop_require_default(require("konva"));
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
class BaseGroup extends _konva.default.Group {
    /**
   * Placeholder method for registering subclass attributes.
   * @private
   */ _childAttributes() {
    // Optionally register subclass attributes here.
    }
    /**
   * Initializes event listeners.
   * @private
   */ _initializeListeners() {
        if (this.node) {
            this.onMouseEnter && this.node.on("mouseenter", this.onMouseEnter);
            this.onMouseOut && this.node.on("mouseout", this.onMouseOut);
            this.onMouseOver && this.node.on("mouseover", this.onMouseOver);
            if (this.editable) {
                this.onMouseDown && this.node.on("mousedown", this.onMouseDown);
                this.onDragStart && this.node.on("dragstart", this.onDragStart);
                this.onDragMove && this.node.on("dragmove", this.onDragMove);
                this.onTransform && this.node.on("transform", this.onTransform);
                this.onTransformEnd && this.node.on("transformend", this.onTransformEnd);
            }
        }
    }
    /**
   * Sets focus on the group.
   * @param {boolean} [nextBool=false] - Indicates whether to set focus.
   */ setFocus(nextBool = false) {
        if (!this.node) return;
        if (nextBool) {
            this.node.fire("drawstart");
        } else {
            this.node.fire("drawend");
        }
    }
    /**
   * Placeholder method for unpacking shape properties.
   * @param {object} shape - The shape object.
   * @param {object} config - Configuration options.
   * @private
   */ _unpack(shape = {}, config = {}) {
        throw new Error("Method '_unpack' must be implemented by subclasses.");
    }
    /**
   * Placeholder method for initializing the shape.
   * @param {object} shape - The shape object.
   * @param {object} config - Configuration options.
   * @private
   */ _init(shape = {}, config = {}) {
        throw new Error("Method '_init' must be implemented by subclasses.");
    }
    /**
   * Placeholder method for updating the shape.
   * @param {object} shape - The shape object.
   * @param {object} config - Configuration options.
   * @private
   */ _update(shape = {}, config = {}) {
        throw new Error("Method '_update' must be implemented by subclasses.");
    }
    /**
   * Placeholder method for pre-update actions.
   * @private
   */ _beforeUpdate() {
    // optional
    }
    /**
   * Executes actions after updating the shape.
   */ _afterUpdate() {
    // optional
    }
    /**
   * Executes actions before updating the shape.
   * @param {object} shape - The shape object.
   * @param {object} config - Configuration options.
   */ beforeUpdate(shape, config) {
        this.shape = shape;
        this.visible(shape.isVisible);
        this._beforeUpdate();
        // unpack specific properties for subclass
        this._unpack(shape, config);
    }
    /**
   * Executes actions after updating the shape.
   */ afterUpdate() {
        this._afterUpdate();
        if (this.node) {
            // make sure child is also visible
            this.node.visible(this.visible());
        }
    }
    /**
   * Initializes the group with the provided shape and configuration.
   * @param {object} shape - The shape object.
   * @param {object} config - Configuration options.
   */ init(shape = {}, config = {}) {
        this.beforeUpdate(shape, config);
        // call specific shape implementation
        this._init(shape, config);
        // initialize listeners and register node
        this._initializeListeners();
        this.add(this.node);
        this.afterUpdate();
    }
    /**
   * Updates the group with the provided shape and configuration.
   * @param {object} shape - The shape object.
   * @param {object} config - Configuration options.
   */ update(shape = {}, config = {}) {
        if (this.shape) {
            this.beforeUpdate(shape, config);
            // call specific shape implementation
            this._update(shape, config);
            this.afterUpdate();
        } else {
            this.init(shape, config);
        }
    }
    setShapeRotation(theta = 0) {
        // we don't want to overide the super() group rotation
        this._rotation = theta;
        this.update(this.shape, {});
    }
    /**
   * Creates an instance of BaseGroup.
   * @constructor
   * @param {object} shape - The shape object.
   * @param {object} config - Configuration options.
   * @param {string} config.id - The ID of the group.
   * @param {string} [config.name='shape-irviewer'] - The name of the group.
   * @param {number} [config.rotation=0] - The rotation angle of the group.
   * @param {boolean} [config.strokeEnabled=true] - Indicates whether stroke is enabled for the group.
   * @param {boolean} [config.editable=true] - Indicates whether the group is editable.
   * @param {boolean} [config.draggable=true] - Indicates whether the group is draggable.
   * @param {Function} [config.onMouseEnter=null] - Callback function for mouse enter event.
   * @param {Function} [config.onMouseOut=null] - Callback function for mouse out event.
   * @param {Function} [config.onMouseDown=null] - Callback function for mouse down event.
   * @param {Function} [config.onMouseOver=null] - Callback function for mouse over event.
   * @param {Function} [config.onDragStart=null] - Callback function for drag start event.
   * @param {Function} [config.onDragMove=null] - Callback function for drag move event.
   * @param {Function} [config.onTransform=null] - Callback function for transform event.
   * @param {Function} [config.onTransformEnd=null] - Callback function for transform end event.
   * @param {Function} [config.onTextChange=null] - Callback function for text change event.
   * @param {...object} rest - Additional properties.
   */ constructor(shape = {}, config = {}){
        super();
        const { // config -->
        id, name = "shape-irviewer", rotation = 0, // bool props -->
        strokeEnabled = true, // visible = true,
        editable = true, draggable = true, // callbacks -->
        onMouseEnter = null, onMouseOut = null, onMouseDown = null, onMouseOver = null, onDragStart = null, onDragMove = null, onTransform = null, onTransformEnd = null, onTextChange = null } = config, rest = _object_without_properties(config, [
            "id",
            "name",
            "rotation",
            "strokeEnabled",
            "editable",
            "draggable",
            "onMouseEnter",
            "onMouseOut",
            "onMouseDown",
            "onMouseOver",
            "onDragStart",
            "onDragMove",
            "onTransform",
            "onTransformEnd",
            "onTextChange"
        ]);
        this.shape = null;
        this._rotation = rotation;
        this.node = null;
        this.stroke = null;
        this.label = null;
        this.attrs.id = id || shape.id || "group-shape";
        // bool props
        this.visible(shape.visible);
        this.strokeEnabled = strokeEnabled;
        this.editable = editable;
        this.draggable = draggable;
        // cache listener callbacks -->
        this.onMouseEnter = onMouseEnter;
        this.onMouseOut = onMouseOut;
        this.onMouseDown = onMouseDown;
        this.onMouseOver = onMouseOver;
        this.onDragStart = onDragStart;
        this.onTransformEnd = onTransformEnd;
        if (onDragMove) {
            this.onDragMove = (e)=>onDragMove(e, this.shape);
        }
        if (onTransform) {
            this.onTransform = (e)=>onTransform(e, this.shape);
        }
        if (onTextChange) {
            this.onTextChange = (e)=>onTextChange(e, this.shape);
        }
        this._childAttributes();
        if (Object.keys(shape).length > 0 && (shape === null || shape === void 0 ? void 0 : shape.points)) {
            const config = _object_spread({
                name
            }, rest);
            this.init(shape, config);
        }
    }
}
